module.exports = __WEBPACK_EXTERNAL_MODULE_109__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM"}
// module id = 109
// module chunks = 0